{
  "customer-selection-form": {
    "buttons": {
      "close": "Fermer",
      "create_new_customer_profile": "Créer un nouveau",
      "select": "Sélectionner",
      "selected": "Sélectionné"
    },
    "text": {
      "search_field_label": "Recherche par numéro de téléphone, courriel ou nom",
      "title": "Sélection des clients"
    }
  }
}
